export default __webpack_public_path__ + "assets/9aaa4e851e5359da9968ea051bd848b0.svg";